import { useState } from "react";
import { Box, Button, Chip, IconButton, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography, } from "@mui/material";
import { AddRounded, DeleteTwoTone, EditTwoTone, LockResetTwoTone, PeopleAltRounded, } from "@mui/icons-material";
import { getAllUsers } from "./user_halper";
import MenuFrame from "../frames/menu_frame";
import Loading1 from "../frames/loading1";
import NewUser from "./new_user";

function UserList() {
    const [userList, setUsersList] = useState(null);
    const [newUser, setNewUsers] = useState(false);

    const initData = async (auth) => {
        if (auth) {
            setUsersList(await getAllUsers());
        }
    };

    const onNewUserClose = () => {
        setNewUsers(false);
    };

    const getRoleColor = (role) => {
        const normalizedRole = String(role || "").toLowerCase();

        if (normalizedRole.includes("office")) return "info";
        if (normalizedRole.includes("client")) return "warning";
        if (normalizedRole.includes("vendor")) return "error";

        return "default";
    };

    return (
        <MenuFrame permission="USERS" screen="USER_LIST" onInit={initData}>
            <Box sx={{ py: 2 }}>
                <Paper elevation={0} sx={{ p: { xs: 2, sm: 2.5 }, mb: 2, border: "1px solid", borderColor: "divider", borderRadius: 3, background: "linear-gradient(135deg, rgba(33,150,243,0.08), rgba(156,39,176,0.04))" }}>
                    <Stack direction={{ xs: "column", sm: "row" }} sx={{ justifyContent: "space-between" }} spacing={2}>
                        <Stack direction="row" spacing={1.5} sx={{ alignItems: "center" }}>
                            <Box sx={{ width: 44, height: 44, borderRadius: 2, display: "flex", alignItems: "center", justifyContent: "center", bgcolor: "primary.main", color: "primary.contrastText" }}>
                                <PeopleAltRounded />
                            </Box>
                            <Box>
                                <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.2 }}>Users</Typography>
                                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.4 }}>Manage user accounts and permissions</Typography>
                            </Box>
                        </Stack>
                        <Button variant="contained" startIcon={<AddRounded />} onClick={() => setNewUsers(true)}
                            sx={{ borderRadius: 2, px: 2, py: 1, textTransform: "none", fontWeight: 600, boxShadow: "none", "&:hover": { boxShadow: "0 4px 12px rgba(0,0,0,0.15)" } }}>
                            New User
                        </Button>
                    </Stack>
                </Paper>

                <NewUser open={newUser} onClose={onNewUserClose} />
                {userList === null || userList.length === 0 ? <Loading1 /> : (
                    <Paper elevation={0} sx={{ overflow: "hidden", border: "1px solid", borderColor: "divider", borderRadius: 3 }}>
                        <Box sx={{ px: 2, py: 1.5, borderBottom: "1px solid", borderColor: "divider", bgcolor: "background.paper" }}>
                            <Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between" }}>
                                <Typography variant="subtitle1" fontWeight={700}>User Accounts</Typography>
                                <Chip sx={{ px: 2, py: 1.5, borderBottom: "1px solid", borderColor: "divider", bgcolor: "background.paper" }} />
                            </Stack>
                        </Box>

                        <TableContainer>
                            <Table aria-label="User login list" sx={{ minWidth: 700, "& .MuiTableCell-root": { borderColor: "divider" } }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="right" sx={{ fontWeight: 700, color: "text.secondary", bgcolor: "background.default", whiteSpace: "nowrap" }}>User ID</TableCell>
                                        <TableCell sx={{ fontWeight: 700, color: "text.secondary", bgcolor: "background.default" }}>Username</TableCell>
                                        <TableCell sx={{ fontWeight: 700, color: "text.secondary", bgcolor: "background.default" }}>Role</TableCell>
                                        <TableCell sx={{ fontWeight: 700, color: "text.secondary", bgcolor: "background.default" }}>Account</TableCell>
                                        <TableCell align="right" sx={{ fontWeight: 700, color: "text.secondary", bgcolor: "background.default", width: 150 }}>Actions</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {userList.map((row, index) => (
                                        <TableRow key={row.user_id} hover sx={{ transition: "background-color 0.15s ease", "&:last-child td": { borderBottom: 0 } }}>
                                            <TableCell align="right" sx={{ fontWeight: 600, color: "text.secondary", whiteSpace: "nowrap" }}>
                                                #{row.user_id}
                                            </TableCell>
                                            <TableCell>
                                                <Typography variant="body2" fontWeight={600}>{row.username}</Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Chip size="small" label={row.role || "N/A"} color={getRoleColor(row.role)} variant="outlined" sx={{ fontWeight: 600, minWidth: 70 }} />
                                            </TableCell>
                                            <TableCell>
                                                <Typography variant="body2" color="text.secondary">{row.ac_id || "—"}</Typography>
                                            </TableCell>
                                            <TableCell align="right">
                                                <Stack direction="row" spacing={0.5} sx={{ justifyContent: "flex-end" }}>
                                                    <Tooltip title="Reset Password">
                                                        <IconButton size="small" color="secondary" aria-label={`Reset password for ${row.username}`} sx={{ borderRadius: 1.5, "&:hover": { bgcolor: "secondary.lighter" } }}>
                                                            <LockResetTwoTone fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Edit User">
                                                        <IconButton size="small" color="primary" aria-label={`Edit ${row.username}`} sx={{ borderRadius: 1.5 }}><EditTwoTone fontSize="small" /></IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Delete User">
                                                        <IconButton size="small" color="error" aria-label={`Delete ${row.username}`} sx={{ borderRadius: 1.5 }}><DeleteTwoTone fontSize="small" /></IconButton>
                                                    </Tooltip>
                                                </Stack>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                )}
            </Box>
        </MenuFrame>
    );
}

export default UserList;
